import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { LogoComponent } from "../logo/logo.component";
import { TranslocoPipe } from '@jsverse/transloco';
import { Router, RouterLink } from '@angular/router';
import { UserDataService } from '../../../core/services/user-data.service';
import { SubscriptionService } from '../../../core/services/subscription.service';
import { Permission } from '../../../core/interfaces/payment-interfaces';

@Component({
  selector: 'app-mobile-drawer',
  standalone: true,
  imports: [CommonModule, LogoComponent, TranslocoPipe, RouterLink],
  templateUrl: './mobile-drawer.component.html',
  styleUrl: './mobile-drawer.component.css'
})
export class MobileDrawerComponent {
  @Input() selectedItemId: number = 0;

  isDrawerOpen = false;

  get isUserOnTrial(): boolean {
    return this.userData.getUser()?.membership?.membership_type === 'TRIAL';
  }

  get trialDaysLeft(): string {
    if (this.isUserOnTrial) {
      const validToStr = this.userData.getUser()?.membership?.valid_to;
      if (validToStr) {
        const validTo = new Date(validToStr);
        const currentDate = new Date();
        const timeDiff = validTo.getTime() - currentDate.getTime();
        const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

        return daysLeft > 0 ? `${daysLeft > 99 ? '99+' : daysLeft}` : "0";
      }
    }
    return '';
  }

  constructor(private router: Router, private userData: UserDataService, private subscriptionService: SubscriptionService) { }

  openDrawer() {
    this.isDrawerOpen = true;
  }

  closeDrawer() {
    this.isDrawerOpen = false;
  }

  openPlansPage() {
    this.router.navigate(['/settings/plans']);
    this.closeDrawer();
  }

  get hasDashboardViewPermission(): boolean {
    const user = this.userData.getUser();
    const membership = user?.membership;

    if (!membership) {
      return false;
    }

    if (user && user.is_active && this.subscriptionService.membershipHasPermission(membership, Permission.VIEW_DASHBOARD, true)) {
      return true;
    }
    return false;
  }
}
